module.exports = __webpack_public_path__ + "static/media/br.d3c566d2.webp";